<template>
  <slot v-if="permission" />
</template>

<script lang="ts" setup>
/**
 * Find a way to use multiple GrantCallbacks (to keep syntax easy and lowest computations possible)
 * We could compute grants on login and use only boolean values(on logout we reset them)
 * Ignore the transition warnings as they refer to this component not having a root element when permission is not met
 */
const { permission } = defineProps<{ permission: boolean }>()
</script>

<style>

</style>
